<div class="page-header">
  <div>
    <h1>Kurse</h1>
    <p>Module, Lektionen und später die Fragenverwaltung.</p>
  </div>
</div>

@if (courses().length) {
  <section class="grid gap-4">
    @for (course of courses(); track course.id) {
      <article class="panel">
        <span class="badge">Modul {{ course.moduleNumber }}</span>
        <h2>{{ course.title }}</h2>
        <p>{{ course.durationMinutes }} Minuten · {{ course.language }}</p>
      </article>
    }
  </section>
} @else {
  <div class="empty">Noch keine aktiven Kurse geladen.</div>
}
  
